import {
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cilbadge,
  cibGithub,
  cibStackOverflow,
  cilclouddownload,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  
  cibCcAmex,
  
} from "@coreui/icons";
import { cifUs, cifBr, cifIn, cifFr, cifEs, cifPl } from "@coreui/icons";
import {
  cilAt,
  cilApple,
  cilShieldAlt,
  cilArrowRight,
  cilArrowLeft,
  cilAmericanFootball,
  cilBadge,
  cilBank,
  cilShieldCheck,
  
  cilBookmark,
  cilBan,
  cilBasket,
  cilBell,
  cilBrightness,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilCheckAlt,
  cilChevronBottom,
  cilChevronTop,
  cilCheckCircle,
  cilCommentSquare,
  cilContact,
  cilCursor,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEqualizer,
  cilEuro,
  cilFingerprint,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilFolder,
  cilamericanfootbal,
  cilFork,
  cilJustifyCenter,
  cilLan,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilLoop,
  cilMagnifyingGlass,
  cilMap,
  cilMoon,
  cilOptions,
  cilPencil,
  cilPeople,
  cilPhone,
  cilPuzzle,
  cilSettings,
  cilSpeech,
  cilSpeedometer,
  cilFlagAlt,
  cilStar,
  cilSortNumericUp,
  cilSortNumericDown,
  cilThumbUp,
  cilThumbDown,
  cilTriangle,
  cilTask,
  cilUser,
  cilshieldalt,
  cilUserFemale,
  cilUserFollow,
  cilWc,
  cilWeightlifitng,
  cilXCircle,
  cilNotes,
  cilCalendarCheck,
  cilAddressBook,
  cilDoor,
  } from "@coreui/icons";
import { logo } from "./logo";

export const iconsSet = Object.assign(
  {},
  { logo },
  {
    cilNotes,
    cilAt,
    cilApple,
    cilArrowRight,
    cilArrowLeft,
    cilAmericanFootball,
    cilBadge,
    cilBank,
    cilShieldAlt,
    cilBookmark,
    cilBan,
   
    cilamericanfootbal,
    cilBasket,
    cilBell,
    cilshieldalt,
    cilBrightness,
    cilCalculator,
    cilCalendar,
    cilCloudDownload,
    cilChartPie,
    cilCheck,
    
    cilCheckAlt,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilbadge,
    cilCommentSquare,
    cilContact,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEqualizer,
    cilEuro,
    cilFingerprint,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilFolder,
    cilFork,
    cilJustifyCenter,
    cilLan,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilLoop,
    cilMagnifyingGlass,
    cilMap,
    cilMoon,
    cilOptions,
    cilPencil,
    cilPeople,
    cilPhone,
    cilPuzzle,
    cilSettings,
    cilShieldAlt,
    cilFlagAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilSortNumericUp,
    cilSortNumericDown,
    cilThumbUp,
    cilThumbDown,
    cilTriangle,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilWc,
    cilWeightlifitng,
    cilXCircle,
    cilCalendarCheck,
    cilAddressBook,
    cilDoor,
  },
  {
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl,
  },
  {
    cilclouddownload,
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibStackOverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard,
    cibCcVisa,
    cibStripe,
    cibPaypal,
    cibGooglePay,
    cibCcAmex,
  }
);
